import { jsonRpcUrlMap, networkToChainId } from "../constants/EIP1193";
import { AlchemySupportedChains } from "./balances/alchemyBalance";
import { fetchSkyMavisTransfers } from "./backendHelpers";

export const getAssetTransfers = async (address: string) => {
    console.log("Start 1");
    // Get asset transfer TO from Alchemy
    const to = await getAssetTransferFromAlchemy(address, false);

    console.log("Start 2");
    // Get asset transfer FROM from Alchemy
    const from = await getAssetTransferFromAlchemy(address, true);

    console.log("Start 3");
    // Get Sky Mavis transfers from backend
    const skyMavisTransfers = await fetchSkyMavisTransfers(address);
    // console.log("skyMavisTransfers", skyMavisTransfers);
    
    let data: any = [
        ...to.map((t: any) => { return { ...t, type: "TO" } }),
        ...from.map((t: any) => { return { ...t, type: "FROM" } }),
        ...(skyMavisTransfers || []) // Use the transfers array directly from the response
    ];

    // sort data based on metadata.blockTimestamp
    data = data.sort((a: any, b: any) => {
        return new Date(b.metadata.blockTimestamp).getTime() - new Date(a.metadata.blockTimestamp).getTime();
    });
    return data;
}

const getAssetTransferFromAlchemy = async (address: string, from: boolean) => {
    let moreParams = {};
    if (from) {
        moreParams = {
            ...moreParams,
            fromAddress: address
        }
    } else {
        moreParams = {
            ...moreParams,
            toAddress: address
        }
    }

    const options = {
        method: 'POST',
        headers: { accept: 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify({
            id: 1,
            jsonrpc: '2.0',
            method: 'alchemy_getAssetTransfers',
            params: [
                {
                    fromBlock: '0x0',
                    toBlock: 'latest',
                    category: ['erc20'],
                    withMetadata: true,
                    excludeZeroValue: true,
                    maxCount: '0x3e8',
                    ...moreParams
                }
            ]
        })
    };

    let transfers: any[] = [];

    // Loop over AlchemySupportedChains and make a request for every url in jsonRpcUrl
    await Promise.all(AlchemySupportedChains.map(
        async (chain) => {
            //@ts-ignore
            const response: any = await fetch(jsonRpcUrlMap[networkToChainId.get(chain)][0], options);
            const data = await response.json();
            // add chain field in all transfers
            const ts = (data && data["result"] && data["result"]["transfers"]) ? data["result"]["transfers"].map((t: any) => { return { ...t, chain: chain } }) : [];
            transfers = [...transfers, ...ts];
        }
    ));

    return transfers;
}